var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEvening = function SvgEvening(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    "aria-hidden": "true",
    className: "iconify iconify--twemoji",
    viewBox: "0 0 36 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFAC33",
    d: "M13 6s0-2 2-2 2 2 2 2v2s0 2-2 2-2-2-2-2zM4 17s2 0 2 2-2 2-2 2H2s-2 0-2-2 2-2 2-2zm3.872-6.957s1.414 1.414 0 2.828-2.828 0-2.828 0l-1.415-1.414s-1.414-1.414 0-2.829c1.415-1.414 2.829 0 2.829 0zm17.085 2.828s-1.414 1.414-2.828 0 0-2.828 0-2.828l1.414-1.414s1.414-1.414 2.828 0 0 2.828 0 2.828z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 19,
    r: 8,
    fill: "#FFAC33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M28.223 16.8c-.803 0-1.575.119-2.304.34-.862-2.409-3.201-4.14-5.961-4.14-2.959 0-5.437 1.991-6.123 4.675a4.4 4.4 0 0 0-2.626-.875c-2.417 0-4.375 1.914-4.375 4.275 0 .573.12 1.118.329 1.618a5 5 0 0 0-1.302-.193C3.176 22.5 1 24.626 1 27.25S3.176 32 5.861 32h22.361C32.518 32 36 28.598 36 24.4s-3.482-7.6-7.777-7.6"
  })));
};
export { SvgEvening as ReactComponent };
export default __webpack_public_path__ + "fc2c59196ba366152e02efbdf88ba909.svg";